import { z } from 'zod';
import { DocumentCornSchema, InspectionCornSchema } from '../base.js';
import { MediaMetadataSchema } from '../base/mediaMetadata.js';
export const DocumentSchema = z.object({
    description: z.string().optional(),
    documentId: DocumentCornSchema,
    fileName: z.string(),
    inspectionId: InspectionCornSchema,
    labels: z.array(z.string()),
    metadata: MediaMetadataSchema.default({}),
    s3Key: z.string(),
    title: z.string(),
    uploadedBy: z.string(),
    uploadedDate: z.string(),
});
export const DocumentWithSignedUrlSchema = DocumentSchema.omit({ s3Key: true }).extend({
    signedUrl: z.url(),
});
